import { RankContainerStyles } from '@dealstack/frontend/shared/components/RankContainer/RankContainer.styles.tsx';
import { Text } from '@mantine/core';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { SortTag } from '@dealstack/frontend/shared/components/SortTag/SortTag.tsx';

export const RankContainerPlaceholder = () => {
	const tCapManage = useTranslationCapManage();

	return (
		<RankContainerStyles className="placeholder">
			<div className="rank-header">
				<div className="rank-info">
					<SortTag label="" />

					<div className="rank-name">
						<Text c="gray.9" className="display-name">
							{tCapManage('rankContainerPlaceholder.label.newRank')}
						</Text>
					</div>
				</div>
			</div>

			<div className="rank-content">
				<div className="placeholder">
					<Text c="gray.9">{tCapManage('rankContainerPlaceholder.drop')}</Text>
				</div>
			</div>
		</RankContainerStyles>
	);
};
